import React, {Component} from 'react';
import PropTypes from 'prop-types';

import AddressAutoComplete from 'js/components/google/maps/address_autocomplete/index';

class AddressInput extends Component {
    static propTypes = {
        value: PropTypes.string,
        GoogleMapsApi: PropTypes.object,
        onPlaceSelected: PropTypes.func.isRequired,
        validationState: PropTypes.string,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        value: '',
        validationState: null
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedPlace: null
        };
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.value !== this.props.value;
    }

    render() {
        const {GoogleMapsApi, onPlaceSelected, validationState, value, onChange} = this.props;

        return (
            <AddressAutoComplete
                GoogleMapsApi={GoogleMapsApi}
                onPlaceSelected={onPlaceSelected}
                value={value}
                onChange={onChange}
                validationState={validationState}
            />
        );
    }
}

export default AddressInput;



// WEBPACK FOOTER //
// ./creator/components/address_info_form/components/address_input.js